// components/Sidebar.jsx
import React from 'react';

const Sidebar = ({ sections, activeSection, setActiveSection }) => {
  return (
    <div className="w-64 bg-gradient-to-b from-green-800 to-green-900 shadow-2xl transform transition-all duration-300 ease-in-out">
      {/* Header */}
      <div className="p-6 border-b border-green-700">
        <h1 className="text-2xl font-bold text-white text-center tracking-wide">
          Dashboard
        </h1>
        <div className="w-16 h-1 bg-green-400 mx-auto mt-2 rounded-full"></div>
      </div>

      {/* Navigation */}
      <nav className="p-4 space-y-2">
        {sections.map((section) => (
          <button
            key={section.id}
            onClick={() => section.available && setActiveSection(section.id)}
            className={`w-full text-left p-4 rounded-xl transition-all duration-300 ease-out transform hover:scale-105 hover:shadow-lg ${
              activeSection === section.id
                ? 'bg-green-600 text-white shadow-lg scale-105 border-l-4 border-green-400'
                : section.available
                ? 'text-green-100 hover:bg-green-700 hover:text-white'
                : 'text-green-300 opacity-50 cursor-not-allowed'
            }`}
          >
            <div className="flex items-center justify-between">
              <span className="font-semibold">{section.name}</span>
              {!section.available && (
                <span className="text-xs bg-green-900 text-green-300 px-2 py-1 rounded-full">
                  Soon
                </span>
              )}
              {activeSection === section.id && (
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
              )}
            </div>
          </button>
        ))}
      </nav>

      {/* Footer */}
      <div className="absolute bottom-0 w-64 p-4 border-t border-green-700">
        <div className="text-center text-green-300 text-sm">
          <div className="w-8 h-8 bg-green-600 rounded-full mx-auto mb-2 flex items-center justify-center">
            <span className="font-bold text-white">A</span>
          </div>
          <p>Admin Panel</p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;